import { render } from "./Container.vue.js?vue&type=template&id=94473ee2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=template&id=94473ee2"
import script from "./Container.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/layouts/Container.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94473ee2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94473ee2', __exports__)) {
    api.reload('94473ee2', __exports__)
  }
  
  module.hot.accept("./Container.vue.js?vue&type=template&id=94473ee2!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./Container.vue?vue&type=template&id=94473ee2", () => {
    api.rerender('94473ee2', render)
  })

}


export default __exports__